import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
import { format } from '@/@core/utils/string';
let SystemSamlApi = class SystemSamlApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    getSamlQuery(params) {
        const url = this.urls.getSamlQuery;
        return this.http.get({
            url,
            params,
        });
    }
    addSystemSaml(params) {
        const url = this.urls.updateOrAddSaml;
        return this.http.post({
            url,
            data: params,
        });
    }
    updatSystemSaml(params) {
        const url = this.urls.updateOrAddSaml;
        return this.http.put({
            url,
            data: params,
        });
    }
    deleteSamlById(params) {
        const url = format(this.urls.deleteSamlById, params);
        return this.http.delete({
            url,
        });
    }
};
SystemSamlApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.SystemSamlApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], SystemSamlApi);
export { SystemSamlApi };
